module.exports = __webpack_public_path__ + "media/images/pic/compare/after-a7dfd52e8e8fb86362524b203b6c3746.jpg";